<template>
  <div class="main">
    <back title="西餐料理金领班"></back>
    <landingBanner
      landingUrl="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/westfood9/banner.jpg"
    ></landingBanner>

    <div class="content">
      <indexTitle
        title1="免费获取课程学费"
        title2="TO GET THE TUITION"
      ></indexTitle>
      <footerForm color="#fff" bag="#a96b04" words="点击报名"></footerForm>
      <indexTitle
        title1="课程学习内容"
        title2="包含法式、意式、德式、美式等340余款学习品种"
      ></indexTitle>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/westfood9/part1.jpg"
      >
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <indexTitle
        title1="就业前景"
        title2="理想就业，绵阳欧米奇是你正确的选择"
      ></indexTitle>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/westfood9/part2.jpg"
      >
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <find goto></find>
      <indexTitle title1="学生作品" title2="高颜值学生作品一览"></indexTitle>
      <van-swipe :autoplay="3000" indicator-color="white">
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/westfood9/part3-2.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/westfood9/part3-1.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/westfood9/part3-3.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
      </van-swipe>
      <indexTitle
        title1="师资力量"
        title2="精英名师亲授，助力你的成功事业路！"
      ></indexTitle>
      <teacher :teacherUrl="teacherUrl"></teacher>
      <find goto></find>
      <indexTitle
        title1="六大核心教学优势"
        title2="小班授课、实操教学模式，塑造学生的创新能力"
      ></indexTitle>
      <good8></good8>
      <indexTitle
        title1="成功创业学员"
        title2="迷茫的年纪，成功的选择"
      ></indexTitle>
      <van-swipe :autoplay="3000" indicator-color="#a96b04">
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/westfood9/part5-1.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/westfood9/part5-2.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
      </van-swipe>
      <indexTitle
        title1="优秀就业学员"
        title2="为了同一个梦，欧米奇学子靠行动驱动人生！"
      ></indexTitle>
      <van-swipe :autoplay="3000" indicator-color="#a96b04">
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/westfood9/part6-1.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
        <van-swipe-item>
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/westfood9/part6-2.jpg"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
        </van-swipe-item>
      </van-swipe>
      <indexTitle title1="推荐就业" title2="校企合作，定向委托"></indexTitle>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/westfood9/logos.jpg"
      >
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
    </div>
    <indexTitle
      title1="选择课程，了解学费"
      title2="TO GET THE TUITION"
    ></indexTitle>
    <footerForm color="#fff" bag="#a96b04" words="点击获取学费报价"></footerForm>
    <foot></foot>
  </div>
</template>
<script>
export default {
  data() {
    return {
      teacherUrl: [
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/westfood9/part4-1.jpg",
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/westfood9/part4-2.jpg"
      ]
    };
  },
  components: {
    back: () => import("../../../components/head/back"),
    landingBanner: () => import("../../../components/common/landing-banner"),
    teacher: () => import("../../../components/common/teacher"),
    good8: () => import("../../../components/common/good8"),
    do: () => import("../../../components/common/do"),
    foot: () => import("@/components/foot/foot"),
    topForm: () => import("@/components/common/topForm"),
    find: () => import("@/components/common/find"),
    footerForm: () => import("@/components/form/footerForm"),
    indexTitle: () => import("@/components/common/indexTitle")
  },
  mothods() {}
};
</script>
<style lang="less" scoped>
/deep/ .van-swipe__indicators{
  bottom: 15px;
    left: 10%;
}
.main {
  margin-top: 50px;
}
.content {
  padding: 10px;
}
.title {
  width: 100%;
  height: 65px;
  margin-top: 20px;
  margin-bottom: 10px;
  text-align: center;
}
.title1 {
  width: 100%;
  height: 30px;
  font-weight: 600;
  font-size: 1.5em;
  line-height: 25px;
}
.title2 {
  width: 100%;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
.title3 {
  width: 100%;
  height: 15px;
  line-height: 15px;
  font-size: 12px;
}

.do-more {
  color: rgb(0, 0, 0, 0.6);
  width: 90%;
  margin-top: 5px;
  line-height: 35px;
  height: 35px;
  background-image: linear-gradient(
    to right,
    rgb(249, 213, 227) 0%,
    rgb(206, 233, 254) 100%
  );
  border: none;
}
</style>
